import { FC } from "preact/compat";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import { ExpenseViewStatus } from "~/core";
import { PAID_UNKNOWN } from "~/core/slices/api/expense";
import { me, useApp } from "~/core/store";
import { dateFromApi, prettyNum } from "~/utils";
import { ExpenseLinkProps } from "./interfaces";
import cn from "classnames";

const TODAY = new Date();
const STATUS_TEXT = {
    [ExpenseViewStatus.Submitted]: "Submitted",
    [ExpenseViewStatus.NotSubmitted]: "Not Submitted",
    [ExpenseViewStatus.Approved]: "Approved",
    [ExpenseViewStatus.BookedUnpaid]: "Booked Not Paid",
    [ExpenseViewStatus.BookedPaid]: "Booked Paid",
    [ExpenseViewStatus.Deleted]: "Deleted",
};

const formatDate = (date: number) => {
    const d = dateFromApi(date);

    if (d.getFullYear() === TODAY.getFullYear()) {
        return format(d, "dd MMM");
    }

    return format(d, "dd MMM yyyy");
};

const ExpenseLink: FC<ExpenseLinkProps> = ({ expense }) => {
    const { api } = useApp();
    const currencyCode = api.currency.base.value?.code;

    return (
        <Link
            to={me(`admin/expenses?expense=${expense.id}`)}
            className="block border border-gray-200 rounded-md px-3 py-1 hover:bg-sky-50"
        >
            <div className="flex items-center justify-between">
                <h3 className="truncate">{expense.description}</h3>
                <span className="whitespace-nowrap text-sm font-bold">
                    {prettyNum(expense.amount?.toNumber() ?? 0)} {currencyCode}
                </span>
            </div>
            <div className="flex items-center justify-between text-xs mt-1">
                <div
                    className={cn(
                        "flex items-center whitespace-nowrap",
                        // @LINK expense status color
                        expense.status === ExpenseViewStatus.Submitted
                            ? "text-[#85A553]"
                            : expense.status ===
                                    ExpenseViewStatus.NotSubmitted &&
                                expense.complete
                              ? "text-[#6B7280]"
                              : "text-[#FF7448]",
                    )}
                >
                    {STATUS_TEXT[expense.status] ?? "Unknown"}
                    {expense.paid_out_date !== 0 &&
                        expense.paid_out_date !== PAID_UNKNOWN &&
                        `, ${formatDate(expense.paid_out_date)}`}
                </div>
                <span>{format(dateFromApi(expense.date), "dd MMM")}</span>
            </div>
        </Link>
    );
};

export default ExpenseLink;
